/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { pluginsAddPluginServer } from "../funcs/pluginsAddPluginServer.js";
import { pluginsCreatePlugin } from "../funcs/pluginsCreatePlugin.js";
import { pluginsDeletePlugin } from "../funcs/pluginsDeletePlugin.js";
import { pluginsDownloadCodexInstallScript } from "../funcs/pluginsDownloadCodexInstallScript.js";
import { pluginsDownloadObservabilityPlugin } from "../funcs/pluginsDownloadObservabilityPlugin.js";
import { pluginsDownloadPluginPackage } from "../funcs/pluginsDownloadPluginPackage.js";
import { pluginsGetDistributionPlugin } from "../funcs/pluginsGetDistributionPlugin.js";
import { pluginsGetMarketplaceSettings } from "../funcs/pluginsGetMarketplaceSettings.js";
import { pluginsGetPlugin } from "../funcs/pluginsGetPlugin.js";
import { pluginsGetPublishStatus } from "../funcs/pluginsGetPublishStatus.js";
import { pluginsListAudiences } from "../funcs/pluginsListAudiences.js";
import { pluginsListDistributionPlugins } from "../funcs/pluginsListDistributionPlugins.js";
import { pluginsListPlugins } from "../funcs/pluginsListPlugins.js";
import { pluginsPublishPlugins } from "../funcs/pluginsPublishPlugins.js";
import { pluginsRemovePluginServer } from "../funcs/pluginsRemovePluginServer.js";
import { pluginsRotateObservabilityCredential } from "../funcs/pluginsRotateObservabilityCredential.js";
import { pluginsSetPluginAssignments } from "../funcs/pluginsSetPluginAssignments.js";
import { pluginsUpdateMarketplaceSettings } from "../funcs/pluginsUpdateMarketplaceSettings.js";
import { pluginsUpdatePlugin } from "../funcs/pluginsUpdatePlugin.js";
import { pluginsUpdatePluginServer } from "../funcs/pluginsUpdatePluginServer.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { DistributionPlugin } from "../models/components/distributionplugin.js";
import { ListAudiencesResult } from "../models/components/listaudiencesresult.js";
import { ListDistributionPluginsResult } from "../models/components/listdistributionpluginsresult.js";
import { ListPluginsResult } from "../models/components/listpluginsresult.js";
import { MarketplaceSettingsResult } from "../models/components/marketplacesettingsresult.js";
import { Plugin } from "../models/components/plugin.js";
import { PluginServer } from "../models/components/pluginserver.js";
import { PublishPluginsResult } from "../models/components/publishpluginsresult.js";
import { PublishStatusResult } from "../models/components/publishstatusresult.js";
import { RotateObservabilityCredentialResult } from "../models/components/rotateobservabilitycredentialresult.js";
import { SetPluginAssignmentsResponseBody } from "../models/components/setpluginassignmentsresponsebody.js";
import { UpdateMarketplaceSettingsResult } from "../models/components/updatemarketplacesettingsresult.js";
import {
  AddPluginServerRequest,
  AddPluginServerSecurity,
} from "../models/operations/addpluginserver.js";
import {
  CreatePluginRequest,
  CreatePluginSecurity,
} from "../models/operations/createplugin.js";
import {
  DeletePluginRequest,
  DeletePluginSecurity,
} from "../models/operations/deleteplugin.js";
import {
  DownloadCodexInstallScriptRequest,
  DownloadCodexInstallScriptResponse,
  DownloadCodexInstallScriptSecurity,
} from "../models/operations/downloadcodexinstallscript.js";
import {
  DownloadObservabilityPluginRequest,
  DownloadObservabilityPluginResponse,
  DownloadObservabilityPluginSecurity,
} from "../models/operations/downloadobservabilityplugin.js";
import {
  DownloadPluginPackageRequest,
  DownloadPluginPackageResponse,
  DownloadPluginPackageSecurity,
} from "../models/operations/downloadpluginpackage.js";
import {
  GetDistributionPluginRequest,
  GetDistributionPluginSecurity,
} from "../models/operations/getdistributionplugin.js";
import {
  GetMarketplaceSettingsRequest,
  GetMarketplaceSettingsSecurity,
} from "../models/operations/getmarketplacesettings.js";
import {
  GetPluginRequest,
  GetPluginSecurity,
} from "../models/operations/getplugin.js";
import {
  GetPublishStatusRequest,
  GetPublishStatusSecurity,
} from "../models/operations/getpublishstatus.js";
import {
  ListAudiencesRequest,
  ListAudiencesSecurity,
} from "../models/operations/listaudiences.js";
import {
  ListDistributionPluginsRequest,
  ListDistributionPluginsSecurity,
} from "../models/operations/listdistributionplugins.js";
import {
  ListPluginsRequest,
  ListPluginsSecurity,
} from "../models/operations/listplugins.js";
import {
  PublishPluginsRequest,
  PublishPluginsSecurity,
} from "../models/operations/publishplugins.js";
import {
  RemovePluginServerRequest,
  RemovePluginServerSecurity,
} from "../models/operations/removepluginserver.js";
import {
  RotateObservabilityCredentialRequest,
  RotateObservabilityCredentialSecurity,
} from "../models/operations/rotateobservabilitycredential.js";
import {
  SetPluginAssignmentsRequest,
  SetPluginAssignmentsSecurity,
} from "../models/operations/setpluginassignments.js";
import {
  UpdateMarketplaceSettingsRequest,
  UpdateMarketplaceSettingsSecurity,
} from "../models/operations/updatemarketplacesettings.js";
import {
  UpdatePluginRequest,
  UpdatePluginSecurity,
} from "../models/operations/updateplugin.js";
import {
  UpdatePluginServerRequest,
  UpdatePluginServerSecurity,
} from "../models/operations/updatepluginserver.js";
import { unwrapAsync } from "../types/fp.js";

export class Plugins extends ClientSDK {
  /**
   * addPluginServer plugins
   *
   * @remarks
   * Add an MCP server to a plugin.
   */
  async addPluginServer(
    request: AddPluginServerRequest,
    security?: AddPluginServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PluginServer> {
    return unwrapAsync(pluginsAddPluginServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createPlugin plugins
   *
   * @remarks
   * Create a new plugin.
   */
  async createPlugin(
    request: CreatePluginRequest,
    security?: CreatePluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Plugin> {
    return unwrapAsync(pluginsCreatePlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deletePlugin plugins
   *
   * @remarks
   * Delete a plugin.
   */
  async deletePlugin(
    request: DeletePluginRequest,
    security?: DeletePluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(pluginsDeletePlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * downloadCodexInstallScript plugins
   *
   * @remarks
   * Download a bash install script that registers the Codex observability marketplace and pre-approves all hook events. Requires a published marketplace.
   */
  async downloadCodexInstallScript(
    request?: DownloadCodexInstallScriptRequest | undefined,
    security?: DownloadCodexInstallScriptSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DownloadCodexInstallScriptResponse> {
    return unwrapAsync(pluginsDownloadCodexInstallScript(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * downloadObservabilityPlugin plugins
   *
   * @remarks
   * Download a ZIP of the per-org observability plugin (Speakeasy hooks). Mints a fresh hooks-scoped API key on each download and embeds it in the plugin's hook script.
   */
  async downloadObservabilityPlugin(
    request: DownloadObservabilityPluginRequest,
    security?: DownloadObservabilityPluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DownloadObservabilityPluginResponse> {
    return unwrapAsync(pluginsDownloadObservabilityPlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * downloadPluginPackage plugins
   *
   * @remarks
   * Download a ZIP of a single plugin package for direct installation.
   */
  async downloadPluginPackage(
    request: DownloadPluginPackageRequest,
    security?: DownloadPluginPackageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DownloadPluginPackageResponse> {
    return unwrapAsync(pluginsDownloadPluginPackage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDistributionPlugin plugins
   *
   * @remarks
   * Get minimal distribution target metadata for a skill the caller can read. Requires skill:read, not org:read.
   */
  async getDistributionPlugin(
    request: GetDistributionPluginRequest,
    security?: GetDistributionPluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DistributionPlugin> {
    return unwrapAsync(pluginsGetDistributionPlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMarketplaceSettings plugins
   *
   * @remarks
   * Get the marketplace settings for the current project, including the effective marketplace name and the server-side default.
   */
  async getMarketplaceSettings(
    request?: GetMarketplaceSettingsRequest | undefined,
    security?: GetMarketplaceSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<MarketplaceSettingsResult> {
    return unwrapAsync(pluginsGetMarketplaceSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getPlugin plugins
   *
   * @remarks
   * Get a plugin with its servers and assignments.
   */
  async getPlugin(
    request: GetPluginRequest,
    security?: GetPluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Plugin> {
    return unwrapAsync(pluginsGetPlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getPublishStatus plugins
   *
   * @remarks
   * Check whether GitHub publishing is configured and connected for this project.
   */
  async getPublishStatus(
    request?: GetPublishStatusRequest | undefined,
    security?: GetPublishStatusSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PublishStatusResult> {
    return unwrapAsync(pluginsGetPublishStatus(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAudiences plugins
   *
   * @remarks
   * List the audiences that can be assigned to plugins.
   */
  async listAudiences(
    request?: ListAudiencesRequest | undefined,
    security?: ListAudiencesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAudiencesResult> {
    return unwrapAsync(pluginsListAudiences(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDistributionPlugins plugins
   *
   * @remarks
   * List minimal distribution targets for a skill the caller can read. Requires skill:read, not org:read.
   */
  async listDistributionPlugins(
    request: ListDistributionPluginsRequest,
    security?: ListDistributionPluginsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDistributionPluginsResult> {
    return unwrapAsync(pluginsListDistributionPlugins(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listPlugins plugins
   *
   * @remarks
   * List all plugins for the current project.
   */
  async listPlugins(
    request?: ListPluginsRequest | undefined,
    security?: ListPluginsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListPluginsResult> {
    return unwrapAsync(pluginsListPlugins(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * publishPlugins plugins
   *
   * @remarks
   * Generate and publish all plugin packages to a GitHub repository.
   */
  async publishPlugins(
    request: PublishPluginsRequest,
    security?: PublishPluginsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PublishPluginsResult> {
    return unwrapAsync(pluginsPublishPlugins(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * removePluginServer plugins
   *
   * @remarks
   * Remove a server from a plugin.
   */
  async removePluginServer(
    request: RemovePluginServerRequest,
    security?: RemovePluginServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(pluginsRemovePluginServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateObservabilityCredential plugins
   *
   * @remarks
   * Rotate the observability plugin's hooks-scoped ingest credential. Mints a replacement key, republishes the marketplace when possible so installs pick it up, and either revokes previous plugin hooks keys immediately or keeps them valid for a grace window.
   */
  async rotateObservabilityCredential(
    request: RotateObservabilityCredentialRequest,
    security?: RotateObservabilityCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RotateObservabilityCredentialResult> {
    return unwrapAsync(pluginsRotateObservabilityCredential(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setPluginAssignments plugins
   *
   * @remarks
   * Replace all assignments for a plugin with the given list of principal URNs.
   */
  async setPluginAssignments(
    request: SetPluginAssignmentsRequest,
    security?: SetPluginAssignmentsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SetPluginAssignmentsResponseBody> {
    return unwrapAsync(pluginsSetPluginAssignments(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateMarketplaceSettings plugins
   *
   * @remarks
   * Update the marketplace settings for the current project. If a marketplace is already published, the updated settings are pushed to GitHub before the call returns.
   */
  async updateMarketplaceSettings(
    request: UpdateMarketplaceSettingsRequest,
    security?: UpdateMarketplaceSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpdateMarketplaceSettingsResult> {
    return unwrapAsync(pluginsUpdateMarketplaceSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updatePlugin plugins
   *
   * @remarks
   * Update plugin metadata.
   */
  async updatePlugin(
    request: UpdatePluginRequest,
    security?: UpdatePluginSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Plugin> {
    return unwrapAsync(pluginsUpdatePlugin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updatePluginServer plugins
   *
   * @remarks
   * Update a server's configuration within a plugin.
   */
  async updatePluginServer(
    request: UpdatePluginServerRequest,
    security?: UpdatePluginServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PluginServer> {
    return unwrapAsync(pluginsUpdatePluginServer(
      this,
      request,
      security,
      options,
    ));
  }
}
